.content {
    display: flex;
    align-items: center;
    gap: var(--spacing);
  }
  